import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CELEBRATE_SCORE_DESCRIPTIONS,
  MOOD_SCORE_DESCRIPTIONS,
  PROGRESS_SCORE_DESCRIPTIONS,
  READINESS_SCORE_DESCRIPTIONS,
  SUPPORT_SCORE_DESCRIPTIONS,
} from "./helpers";
import { getOutOfFiveColor } from "app/containers/Dashboard/helpers";
import SimplePopover from "./SimplePopover";
import SupportOrCelebrateDot from "app/containers/WeeklyCheckInMonitor/Tables/SupportOrCelebrateDot";

interface Props {
  type: string;
  showColors?: boolean;
  overallType?: string;
  isCelebrate?: boolean;
  isSupport?: boolean;
}
const CheckinScorePopover = ({
  type,
  showColors = true,
  overallType = "user",
  isCelebrate = false,
  isSupport = false,
}: Readonly<Props>) => {
  const getPopoverContent = (type: string) => {
    let title = "";
    let descriptions: string[] = [];

    switch (type) {
      case "mood":
        title = "Mood Score";
        descriptions = MOOD_SCORE_DESCRIPTIONS;
        break;
      case "progress":
        title = "Progress Score";
        descriptions = PROGRESS_SCORE_DESCRIPTIONS;
        break;
      case "readiness":
        title = "Readiness Score";
        descriptions = READINESS_SCORE_DESCRIPTIONS;
        break;
      case "support":
        title = "Support Score";
        descriptions = SUPPORT_SCORE_DESCRIPTIONS;
        break;
      case "celebrate":
        title = "Celebrate Score";
        descriptions = CELEBRATE_SCORE_DESCRIPTIONS;
        break;
      case "overall":
        title = "Overall Score";
        descriptions = [
          `This is the average of this ${overallType}'s mood, progress, and readiness scores for the current check-in period.`,
        ];
        break;
      case "burnoutRisk":
        title = "Burnout Risk";
        descriptions = [
          "Users may be at risk of burnout if their overall or mood score falls below 3 in 2 or more of their last 4 check-ins.",
        ];
        break;
      case "turnoverRisk":
        title = "Turnover Risk";
        descriptions = [
          "Users may be at risk of turnover if they've been flagged for burnout in 2 or more of their last 3 check-in cycles.",
        ];
        break;
      default:
        break;
    }

    return { title, descriptions };
  };
  const { title, descriptions } = getPopoverContent(type);

  const getCheckinScoreDescription = (score: number, description: string) => (
    <div>
      {showColors ? (
        <>
          {" "}
          <p style={{ display: "inline" }}>
            <b>{score}</b> -
          </p>{" "}
          <div
            className={`status-dot ${getOutOfFiveColor(score)}`}
            style={{ display: "inline-block" }}
          />{" "}
        </>
      ) : null}
      <p style={{ display: "inline" }}>{description}</p>
    </div>
  );

  const getCelebrateOrSupportDescription = (
    index: number,
    description: string
  ) => {
    const endNumber = index * 2;
    const startNumber = endNumber - 1;
    return (
      <div>
        {" "}
        <p style={{ display: "inline" }}>
          <b>
            {startNumber} - {endNumber}
          </b>
        </p>{" "}
        <SupportOrCelebrateDot
          score={startNumber}
          type={isSupport ? "support" : "celebrate"}
          style={{ display: "inline-block" }}
        />{" "}
        <p style={{ display: "inline" }}>{description}</p>
      </div>
    );
  };

  const getCheckInScoreDescriptionPopover = (type: string) => {
    return descriptions.map((description, index) => (
      <div key={index}>
        {isCelebrate || isSupport
          ? getCelebrateOrSupportDescription(
              descriptions.length - index,
              description
            )
          : getCheckinScoreDescription(5 - index, description)}
      </div>
    ));
  };

  return (
    <SimplePopover
      popoverContent={
        <div className="column-gap-16px">
          {getCheckInScoreDescriptionPopover(type)}
        </div>
      }
      trigger="hover"
      popoverTitle={title}
      popoverClassName="checkin-score-popover"
      hideCloseButton
    >
      <FontAwesomeIcon
        icon={["far", "circle-info"]}
        style={{ paddingLeft: "5px" }}
      />
    </SimplePopover>
  );
};

export default CheckinScorePopover;
